import { useState } from "react";

interface ExpandableTextProps {
  text: string | undefined;
  maxChars?: number;
  className?: string;
}

export default function ExpandableText({ text, maxChars = 300, className = "" }: ExpandableTextProps) {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const isLong = text.length > maxChars;
  const displayed = isLong && !expanded ? text.slice(0, maxChars).trimEnd() + "…" : text;

  return (
    <div>
      <p className={`whitespace-pre-line ${className}`}>{displayed}</p>
      {isLong && (
        <button
          onClick={() => setExpanded(e => !e)}
          className="mt-2 text-sm font-medium text-primary hover:underline focus:outline-none"
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
}
